import { createI18n } from 'vue-i18n'
import caLocale from './locales/ca.json'
import enLocale from './locales/en.json'
import esLocale from './locales/es.json'
import etLocale from './locales/et.json'
import noLocale from './locales/nb.json'
import roLocale from './locales/ro.json'

export const localeNames = ['ca', 'en', 'es', 'et', 'nb', 'ro']
export type LocaleCode = 'ca' | 'en' | 'es' | 'et' | 'nb' | 'ro'

const options = {
  locale: import.meta.env.VITE_DEFAULT_LOCALE,
  globalInjection: true,
  fallbackLocale: 'en',
  legacy: false,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  fallbackWarn: false,
  missingWarn: false,
  messages: {
    ca: caLocale,
    en: enLocale,
    es: esLocale,
    et: etLocale,
    nb: noLocale,
    ro: roLocale,
  },
}

export const i18n = createI18n<
  {
    ca: typeof caLocale
    en: typeof enLocale
    es: typeof esLocale
    et: typeof etLocale
    nb: typeof noLocale
    ro: typeof roLocale
  },
  LocaleCode
>(options)
